<template>
  <div class="serviceCommitment">
    <v-publiceTit :titleObj='titleObj'></v-publiceTit>
    <div class="serviceBox clearfix">
      <div class="serviceImg col-sm-4 col-md-4 col-lg-4 hidden-xs"><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/serviceCommitment_img01.png" alt=""></div>
      <div class="serviceCon col-sm-7 col-md-7 col-lg-7 ">采购Saas云平台，是一站式的采购管理与服务平台，可以帮助企业进行生产性和非生产性、核心业务性和非核心业务性的全品类采购业务管理。平台提供了对战略采购、集中采购、招标采购、询报价、电商式采购等多种采购模式与采购方式的全程式管控的能力。</div>
      <div class="serviceImg hidden-sm hidden-md hidden-lg"><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/serviceCommitment_img01.png" alt=""></div>
    </div>
  </div>
</template>
<script>
import publiceTit from '@/components/publiceTit'
export default {
  data () {
    return {
      titleObj: {name: '服务承诺', eng: 'SERVICE COMMITMENT'}
    }
  },
  components: {
    'v-publiceTit': publiceTit
  },
  created () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/serviceCommitment/index.vue